import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=719bfeb9&scoped=true"
import script from "./Product2.vue?vue&type=script&lang=js"
export * from "./Product2.vue?vue&type=script&lang=js"
import style0 from "./Product2.vue?vue&type=style&index=0&id=719bfeb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719bfeb9",
  null
  
)

export default component.exports